import {
  IColumnGroupColumn,
  ISingleValueColumnFilter,
  OG_FISCAL_YEAR_FISCAL_PERIOD_COLUMN_NAME,
  RelativeFilter,
  RelativeFilterOptions
} from '@opengov/reporting-types';
import { toFiscalPeriod } from '@opengov/reporting-formatters';
import { useGetRelativeDateRange } from '../../../editor/filterForm/hooks/useGetRelativeDateRange';

import { TooltipLocaleText } from '../types';

export function useDateFiltersText(
  dateFilters: ISingleValueColumnFilter<IColumnGroupColumn>[] | undefined,
  relativeFilter: RelativeFilter,
  text: TooltipLocaleText,
  entityFiscalYearStartMonth: number,
  rolling?: number,
  asOfDate?: string
): string[] {
  if (!dateFilters || dateFilters.length === 0 || !relativeFilter) {
    return [];
  }

  const isFiscalPeriodColumn = dateFilters[0].columnName === OG_FISCAL_YEAR_FISCAL_PERIOD_COLUMN_NAME;

  if (relativeFilter === RelativeFilterOptions.Custom) {
    if (isFiscalPeriodColumn) {
      return [
        RelativeFilterOptions.Custom,
        dateFilters.map((dateFilter) => toFiscalPeriod(dateFilter.value as string)).join(' - ')
      ];
    }
    return [RelativeFilterOptions.Custom, dateFilters.map((dateFilter) => dateFilter.value).join(' - ')];
  }

  const relativeDateRange = useGetRelativeDateRange({
    type: relativeFilter,
    format: isFiscalPeriodColumn ? 'period' : 'date',
    asOf: asOfDate || '',
    fiscalYearStartMonth: entityFiscalYearStartMonth,
    rolling
  });

  if (relativeDateRange.length === 0) {
    return [];
  }

  const relativeFilterLabel = text.filter.relativeOptions[relativeFilter];
  const isSingleDateFilter = relativeDateRange[0] === relativeDateRange[1];
  const dateFiltersHeader = `${text.filtersTooltip.dateRangeTitle} ${isSingleDateFilter ? '' : relativeFilterLabel}`;
  const dateFiltersValue = isFiscalPeriodColumn
    ? relativeDateRange.map((date) => toFiscalPeriod(date)).join(' - ')
    : relativeDateRange.map((date) => date).join(' - ');

  return [dateFiltersHeader, dateFiltersValue];
}
